<div class="px-4 w-full mb-4" *transloco="let t">
    <button
        (click)="navigateToDashboard()"
        class="w-full rounded-md flex items-center justify-center h-10"
        [class.bg-accent]="!isActive()"
        [class.bg-primary]="isActive()"
    > 
        <mat-icon [svgIcon]="'fluent:grid'" class="text-primary dark:text-white size-6"
            [class.text-primary]="isActive()"
            [class.text-accent]="!isActive()"
        ></mat-icon>
        @if (isClassyLayout) {
            <span class="ml-2 font-bold text-white"
                [class.text-primary]="isActive()"
                [class.text-accent]="!isActive()"
            >
                {{ t('sidebar.dashboard') }}
            </span>
        }
    </button>
</div>